import { identityBaseUrl } from '@trello/config';

export const ATLASSIAN_PROFILE_URL = `${identityBaseUrl}/manage-profile/profile-and-visibility`;
export const TWO_FACTOR_SETUP_URL = `${identityBaseUrl}/manage-profile/security/two-step-verification`;
export const TRELLO_AA_HELP_URL =
  'https://help.trello.com/article/1197-using-trello-with-an-atlassian-account';
